<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { useProfileStore } from '~/stores/profileState'

const { t } = useI18n()
const router = useRouter()
const profileStore = useProfileStore()

const showError500 = ref(false)

// Injektujeme hodnotu z error-handler pluginu
const nuxtApp = useNuxtApp()
nuxtApp.vueApp.provide('showError500', showError500)

// Handler pro zkušení opětovného načtení stránky
function _handleRetry() {
  showError500.value = false
  window.location.reload()
}

// Props pro layout
const props = defineProps({
  showBackButton: {
    type: Boolean,
    default: true
  }
})

// Computed property pro zobrazení tlačítka zpět
const shouldShowBackButton = computed(() => {
  // Skryjeme tlačítko zpět, pokud je profil nekompletní
  // a zároveň je showBackButton povoleno v props
  return props.showBackButton && !profileStore.isProfileIncomplete
})
</script>

<template>
  <div class="flex min-h-screen flex-col">
    <AppNavbar />
      <main class="mb-2 grow px-4">
        <div class="flex w-full py-4">
          <div v-if="shouldShowBackButton" class="mb-0 mt-2 w-full px-4">
            <LocaleLink
              class="inline-flex cursor-pointer items-center text-gray-700 hover:text-gray-900 dark:text-gray-300 dark:hover:text-white"
              @click="router.back()"
            >
              <svg xmlns="http://www.w3.org/2000/svg" class="mr-2 size-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
              {{ t('common.backButton') }}
            </LocaleLink>
          </div>
        </div>
        <div class="flex w-full">
          <slot />
        </div>
      </main>
    <AppFooter />

    <!-- Chat Widget -->
    <LazyIdleCommonChatWidget hydrate-on-idle />
  </div>
</template>
